var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-center" },
    [
      _vm.selfVisible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" },
              ],
              ref: "cusDialog",
              staticClass: "comp cus-dialog",
              class: [_vm.fillScreen ? "fill-screen" : "resize-center"],
              attrs: {
                id: "cus-dialog",
                center: "",
                "append-to-body": "",
                "lock-scroll": "",
                width: _vm.width,
                title: _vm.title,
                visible: _vm.selfVisible,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.selfVisible = $event
                },
              },
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }